
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"layer","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 120 113.1","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M112.4 18.6C99.4 5.7 71.7 0 53.3 0c-18.7 0-32.8 4.7-41 13C3.5 21.9 0 32.6 0 44.8c0 19.4 9.8 40.1 23.4 53.8 3.5 3.5 15.8 14.5 31.9 14.5 16.5 0 28.7-10.1 36.4-17.8 14.8-15 28.3-40.7 28.3-57.5 0-9.5-4.3-15.9-7.6-19.2zM76.1 66.9c-6.2 6.2-12 8.6-17.9 8.6-5.9 0-11.6-2.7-15.3-6.4-4-4-7.6-10.6-7.6-17.5s2.7-11.8 5.8-14.9c4-4 10-6.8 18.9-6.8 7.1 0 13.5 1.6 19.4 7.5 3.8 3.8 4.6 8.3 4.6 11.4 0 4.2-1.7 11.9-7.9 18.1z","fill":"#5952ff"}})])
          )
        }
      }
    